// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ToggleOverlay_overlay__2Wajz"};